import {Worksheet} from "exceljs";
import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";

export const calcDataSetRowsIndex = ({
                                         data,
                                         columns,
                                         headColumns,
                                         ySteps
                                     }: IExportDataSetItem) => {
    let index = 0;
    if (columns?.length && !headColumns?.length) {
        index += 1;
    }
    if (headColumns?.length) {
        if (Array.isArray(headColumns[0])) {
            index += headColumns.length;
        } else {
            index += 1;
        }
    }
    if (data?.length) {
        index += data.length;
    }
    if (ySteps) {
        index += ySteps
    }
    return index
}


export const addYSteps = ({worksheet, ySteps}: {
    worksheet: Worksheet,
    ySteps: number
}) => {
    for (let i = 0; i < ySteps; i++) {
        worksheet.addRow(['']);
    }
}
